import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import React, { useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom';
import { setCurrentUser } from './features/Auth/authSlice';
import { store } from './features/store';

import PageNotFound from './views/pages/PageNotFound/PageNotFound';

import LandingLayouts from './landingcommon/LandingLayouts/LandingLayouts';
import Home from './views/LandingPage/Home/Home';
import AboutUs from './views/LandingPage/cms/AboutUs';
import PrivacyPolicy from './views/LandingPage/cms/PrivacyPolicy';
import RefundsAndCancellations from './views/LandingPage/cms/RefundsAndCancellations';
import CricketPointSystem from './views/LandingPage/cms/CricketPointSystem';
import TermsConditions from './views/LandingPage/cms/TermsConditions';
import HowToPlay from './views/LandingPage/cms/HowToPlay';
import CommunityGuidelines from './views/LandingPage/cms/CommunityGuidelines';
import ContactUs from './views/LandingPage/cms/ContactUs';
import DeleteAccount from './views/LandingPage/cms/DeleteAccount'
import FAQs from './views/LandingPage/cms/FAQs';
import ScrollToTop from './views/pages/ScrollEffects/ScrollToTop';

// var CryptoJS = require("crypto-js");


function App() {
    // useEffect(() => {
    //     if (localStorage.millionaire_security_data) {
    //         var token = CryptoJS.AES.decrypt(localStorage.millionaire_security_data, process.env.REACT_APP_JWT_SECRET);
    //         var decryptedData = JSON.parse(token.toString(CryptoJS.enc.Utf8));
    //         store.dispatch(setCurrentUser(decryptedData));
    //     }
    // }, [])


    return (
        <Router>
             <ScrollToTop />
            <Routes>
                {/* PageNotFound */}
                <Route path="*" element={<PageNotFound />} />

                <Route element={<LandingLayouts />}>
                    <Route path="/" exact element={<Home />} />
                    <Route path="/about-us" exact element={<AboutUs />} />
                    <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
                    <Route path="/refund-policy" exact element={<RefundsAndCancellations />} />
                    <Route path="/terms-conditions" exact element={<TermsConditions />} />
                    <Route path="/how-it-works" exact element={<HowToPlay />} />
                    <Route path="/community-guidelines" exact element={<CommunityGuidelines />} />
                    <Route path="/points-system" exact element={<CricketPointSystem />} />
                    <Route path="/contact-us" exact element={<ContactUs />} />
                    <Route path="/delete-account" exact element={<DeleteAccount />} />
                    <Route path="/faq" exact element={<FAQs />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;
